<template>
  <div class="add-data">
    <el-dialog :closeOnClickModal='false' :title="form.type" :modal-append-to-body='false' :visible.sync="visible"
      width="800px">
      <div class="edit-context" style="min-width:650px;">

        <div class="edit-inp">

          <el-form :rules="rules" ref="form" :model="form" label-width="110px">

            <div class="item-box">
              <!-- 更新章节 -->
              {{chapterList}}
              <el-form-item v-for="(item,index) in formList" :key='index' :label="item.label" :prop="item.field">
                <el-input v-if="item.type=='input'" style="width:228px" v-model="form[item.field]"
                  :placeholder="item.placeholder">
                </el-input>

                <el-select
                  :disabled='(item.field=="course"||item.field=="edition"||item.field=="grade"||item.field=="volume")&&form[item.pField]==""'
                  :placeholder="form[item.pField]==''?item.pPlaceholder:item.placeholder"
                  @change="changeSelect(item.field)" v-if="item.type=='option'" v-model.trim="form[item.field]">
                  <el-option v-for="value in item.optionList" :key="value.id"
                    :label="value.label?value.label:value.name" :value="value.value?value.value:value.name">
                  </el-option>
                </el-select>

                <el-cascader v-if="item.type=='cascader'" v-model="form[item.field]" :placeholder="item.placeholder"
                  :props="defaultProps" :options="item.optionList" :show-all-levels="false">
                </el-cascader>

              </el-form-item>
            </div>

            <el-form-item label="是否公开：" prop="openState">
              <el-radio-group v-model="form.openState">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="附件上传：" style="padding-right:15px">
              <div class="upload-box">
                <el-upload class="upload-demo" list-type='text' :file-list='fileList' :before-upload='beforeUploadFile'
                  :auto-upload='true' action :http-request="uploadSectionFile" :accept="accept"
                  :on-remove="handleRemove" :limit="1" :on-exceed="handleExceed">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传pdf文件，且不超过50MB</div>
                </el-upload>

              </div>
            </el-form-item>
          </el-form>

          <div class="handleBtn">
            <button class="primary" @click.prevent="onSubmit(form)">确认</button>
            <button class="default" @click="closeBtn">取消</button>
          </div>
        </div>

        <div v-if="isPercentage" class="percentage-box">
          <el-progress color='#24ba58' type="circle" :percentage="percentageNum"></el-progress>
        </div>

      </div>

    </el-dialog>

  </div>
</template>

<script>
import utils from "@/util/index";
import {
  ossUpload,
  getUploadPolicies,
  addPaper,
  getChapterTree,
  getLabelSearch,
  setResource,
  getFileInfo
} from "@/network/resourceRequest/api";
import util from "@/util/index";
export default {
  name: "AddTestPaper",
  props: {
    selectDict: {
      default() {
        return {};
      }
    },

    form: {},
    //渲染表单列表
    formList: {
      type: Array,
      default() {
        return [
          {
            field: "name",
            type: "input",
            label: "资源名称：",
            placeholder: "填写资源名称"
          },
          {
            field: "phase",
            type: "option",
            label: "学段：",
            placeholder: "选择学段",
            optionList: []
          },
          {
            field: "course",
            pField: "phase",
            type: "option",
            label: "科目：",
            placeholder: "选择科目",
            pPlaceholder: "请先选择学段",
            optionList: []
          },
          {
            field: "edition",
            pField: "course",
            type: "option",
            label: "版本：",
            placeholder: "选择册别",
            pPlaceholder: "请先选择科目",
            optionList: []
          },
          {
            field: "grade",
            pField: "edition",
            type: "option",
            label: "年级：",
            placeholder: "选择年级",
            pPlaceholder: "请先选择版本",
            optionList: []
          },
          {
            field: "volume",
            pField: "grade",
            type: "option",
            label: "册别：",
            placeholder: "选择册别",
            pPlaceholder: "请先选择年级",
            optionList: []
          },

          {
            field: "chapterId",
            type: "cascader",
            label: "章节：",
            placeholder: "选择章节(可不选)",
            optionList: []
          },
          {
            field: "toll",
            type: "option",
            label: "授权：",
            placeholder: "选择计费方式",
            optionList: [
              {
                value: 1,
                label: "免费"
              },
              {
                value: 2,
                label: "收费"
              }
            ]
          }
        ];
      }
    },
    //是否显示编辑或者添加弹窗------------------------------------------
    centerDialogVisible: { default: false },
    //编辑还是添加
    type: {},
    //编辑的数据
    rowData: {}
  },

  data() {
    return {
      //级联选择器
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
        emitPath: false
      },

      //表单校验规则
      rules: {},
      //是否显示编辑或者添加弹窗--------------------------------------------
      visible: false,
      //旧的表单数据 用于判断表单是否更改过--------------------------------------------
      oldForm: {},
      //文件回显用--------------------------------------------
      fileList: [],
      //上传的文件信息(用于获取)--------------------------------------------
      fileInfoList: [],
      //文件路径回显列表--------------------------------------------
      fileUrlList: [],
      //文件id列表--------------------------------------------
      fileIdList: [],
      //文件封面信息--------------------------------------------
      fileCoverList: [],
      //文件封面id列表--------------------------------------------
      fileCoverIdList: [],
      //封面回显--------------------------------------------
      imageUrl: "",
      //上传成功文件数
      uploadFileNum: [],
      //当前进度
      currentUploadList: [],

      //是否显示百分比状态
      isPercentage: false,

      accept: ""
    };
  },

  created() {
    //初始化校验规则
    this.checkRule();
  },
  watch: {
    //5.给后台明确添加成功
    uploadFileNum(newVal) {
      if (newVal.length != 0) {
        this.uploadedSuccessfully(newVal);
      }
    },

    //弹窗--------------------------------------------
    centerDialogVisible(newValu) {
      this.visible = newValu;
      this.updataDict();
    },

    //弹窗--------------------------------------------
    visible(newVal) {
      this.$emit("update:centerDialogVisible", newVal);
      //当弹窗打开时，更新科目版本年级册别
      if (newVal) {
        let typeList = ["course", "edition", "grade", "volume"];
        this.updateRenderObj(typeList);
      } else {
        this.initFile();
      }
    },

    //编辑的数据--------------------------------------------
    rowData(row) {
      if (row) {
        for (const key in this.form) {
          if (this.form.hasOwnProperty(key)) {
            this.oldForm[key] = this.form[key];
          }
        }
        let ids = { ids: row.fileIdList.join() };
        getFileInfo(ids).then(res => {
          if (res.data.success) {
            this.fileList = [];
            res.data.data.forEach(item => {
              this.fileList.push({ name: item.filename });
            });
          }
        });
      }
    }
  },

  computed: {
    //更新章节
    chapterList() {
      let data = {
        course: this.form.course,
        edition: this.form.edition,
        grade: this.form.grade,
        phase: this.form.phase,
        volume: this.form.volume
      };

      if (
        this.form.course &&
        this.form.edition &&
        this.form.grade &&
        this.form.phase &&
        this.form.volume
      ) {
        getChapterTree(data).then(res => {
          if (res.data.success) {
            this.formList.forEach((item, index) => {
              if (item.field == "chapterId") {
                this.$set(this.formList[index], "optionList", res.data.data);
              }
            });
          }
        });
      }
    },

    //进度条
    percentageNum() {
      let loaded = 0;
      let total = 0;
      this.currentUploadList.forEach(item => {
        loaded += item.loaded;
        total += item.total;
      });
      return ((loaded / total) * 100) | 0;
    }
  },
  methods: {
    //初始化文件
    initFile() {
      //文件回显用--------------------------------------------
      this.fileList = [];
      //上传的文件信息(用于获取)--------------------------------------------
      this.fileInfoList = [];
      //文件id列表--------------------------------------------
      this.fileIdList = [];
      //文件封面信息--------------------------------------------
      this.fileCoverList = [];
      //文件封面id列表--------------------------------------------
      this.fileCoverIdList = [];
      //封面回显--------------------------------------------
      this.imageUrl = "";
      //上传成功文件数
      this.uploadFileNum = [];
      //当前进度
      this.currentUploadList = [];
    },

    //当选项变更时--------------------------------------------
    changeSelect(field) {
      let typeList;
      switch (field) {
        case "phase":
          typeList = ["course", "edition", "grade", "volume"];
          this.updateRenderObj(typeList);
          this.$set(this.form, "course", "");
          this.$set(this.form, "edition", "");
          this.$set(this.form, "grade", "");
          this.$set(this.form, "volume", "");
          break;

        case "course":
          typeList = ["edition", "grade", "volume"];
          this.updateRenderObj(typeList);
          this.$set(this.form, "edition", "");
          this.$set(this.form, "grade", "");
          this.$set(this.form, "volume", "");
          break;

        case "edition":
          typeList = ["grade", "volume"];
          this.updateRenderObj(typeList);
          this.$set(this.form, "grade", "");
          this.$set(this.form, "volume", "");
          break;

        case "grade":
          typeList = ["volume"];
          this.updateRenderObj(typeList);
          this.$set(this.form, "volume", "");
          break;
      }
    },

    //更新列表渲染的对象数据
    updateRenderObj(typeList) {
      //查询数组--------------------------------------------
      let typeArr = [];
      let labelList;
      //封装好查询数组--------------------------------------------
      typeList.forEach(item => {
        switch (item) {
          //科目--------------------------------------------
          case "course":
            labelList = [];
            if (this.form.phase) labelList.push(this.form.phase);
            typeArr.push({
              labels: labelList.join(","),
              type: "course"
            });
            break;
          //版本--------------------------------------------
          case "edition":
            labelList = [];
            if (this.form.phase) labelList.push(this.form.phase);
            if (this.form.course) labelList.push(this.form.course);
            typeArr.push({
              labels: labelList.join(","),
              type: "edition"
            });
            break;
          //年级--------------------------------------------
          case "grade":
            labelList = [];
            if (this.form.phase) labelList.push(this.form.phase);
            if (this.form.course) labelList.push(this.form.course);
            if (this.form.edition) labelList.push(this.form.edition);
            typeArr.push({
              labels: labelList.join(","),
              type: "grade"
            });
            break;

          //册别--------------------------------------------
          case "volume":
            labelList = [];
            if (this.form.phase) labelList.push(this.form.phase);
            if (this.form.course) labelList.push(this.form.course);
            if (this.form.edition) labelList.push(this.form.edition);
            if (this.form.grade) labelList.push(this.form.grade);
            typeArr.push({
              labels: labelList.join(","),
              type: "volume"
            });
            break;
        }
      });

      //查询--------------------------------------------
      typeArr.forEach(item => {
        getLabelSearch(item).then(res => {
          if (res.data.success) {
            this.formList.forEach((formItem, index) => {
              if (formItem.field == item.type) {
                this.$set(this.formList[index], "optionList", res.data.data);
              }
            });
          } else {
            console.log(res.data.code);
          }
        });
      });
    },

    //初始化校验规则
    checkRule() {
      //校验名称
      let validateName = (rule, value, callback) => {
        if (value === "") {
          switch (rule.field) {
            case "name":
              callback(new Error("输入试卷名称"));
            case "srcSchool":
              callback(new Error("输入学校名称"));
            case "number":
              callback(new Error("输入题量"));
              break;
          }
        } else {
          callback();
        }
      };
      //提示规则  //下拉选择框可以默认选择第一个
      this.rules = {
        name: [{ required: true, validator: validateName, trigger: "blur" }],
        srcSchool: [
          { required: true, validator: validateName, trigger: "blur" }
        ],
        number: [{ required: true, validator: validateName, trigger: "blur" }],
        year: [{ required: true, message: "请选择年份", trigger: "change" }],
        course: [{ required: true, message: "请选择科目", trigger: "change" }],
        phase: [{ required: true, message: "请选择学段", trigger: "change" }],
        grade: [{ required: true, message: "请选择年级", trigger: "change" }],
        volume: [{ required: true, message: "请选择册别", trigger: "change" }],
        edition: [{ required: true, message: "请选择版本", trigger: "change" }],
        paperType: [
          { required: true, message: "请选择试卷类型", trigger: "change" }
        ],
        toll: [
          { required: true, message: "请选择授权方式", trigger: "change" }
        ],
        openState: [
          { required: true, message: "请选择公开状态", trigger: "change" }
        ]
      };
      //自定义文件类型
      switch (this.form.type) {
        case "教案":
          this.accept = ".pdf";
          break;
      }
    },

    //表单校验是否通过--------------------------------------------
    formVerification(form) {
      let falg = "";
      this.$refs.form.validate(valid => {
        if (valid) {
          falg = true;
        } else {
          falg = false;
        }
      });
      return falg;
    },

    //关闭窗口按钮--------------------------------------------
    closeBtn() {
      this.$emit("update:centerDialogVisible", false);
    },

    //上传前校验--------------------------------------------
    beforeUploadFile(file) {
      let fileName = file.name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let fileNameLength = file.name.length; //取到文件名长度
      let fileFormat = file.name.substring(fileName + 1, fileNameLength); //截取
      switch (fileFormat) {
        case "pdf":
          break;
        default:
          utils.tips("warning", "非法类型，只支持pdf格式");
          return false;
          break;
      }

      if (file.size / 1024 / 1024 > 50) {
        utils.tips("warning", "文件大小不能超过50M");
        return false;
      }
    },

    //1.自定义上传文件功能（获取文件信息）--------------------------------------------
    uploadSectionFile(params) {
      let url = URL.createObjectURL(params.file);
      this.fileUrlList.push(url);

      let data = {
        filename: params.file.name, //文件名,
        size: params.file.size, //文件大小
        space: this.form.type == "图片" ? "COMMON" : "RESOURCE", //文件存储空间,可选:RESOURCE,COMMON,ICON
        file: params.file,
        params
      };
      this.totalUpload += data.size;
      this.fileInfoList.push(data);
    },

    //1.自定义上传图片功能（获取图片信息）-------delete-------------------------------------
    uploadSectionImg(params) {
      //获取文件路径
      this.imageUrl = window.URL.createObjectURL(params.file);
      let data = {
        filename: params.file.name, //文件名,
        size: params.file.size, //文件大小
        space: "COMMON", //文件存储空间,可选:RESOURCE,COMMON,ICON
        file: params.file,
        params
      };
      this.totalUpload += data.size;
      this.fileCoverList.push(data);
    },

    //2.确定上传--------------------------------------------
    onSubmit(form) {
      //校验表单是否通过再去上传
      let flag = this.formVerification(form);

      if (flag) {
        if (this.type == "add") {
          //上传文件;
          if (this.fileInfoList.length == 0)
            return utils.tips("warning", "请您添加试卷");
          this.uploadFile();
        }

        //当编辑时
        if (this.type == "set") {
          //当文件不修改时，需判断表单信息是否变更--------------------------------------------
          if (this.checkFormChanges() && this.fileList.length != 0) {
            utils.tips("error", "信息未修改");
            return;
          }
          //文件删除后--------------------------------------------
          if (this.fileList.length == 0 && this.fileInfoList.length == 0) {
            utils.tips("error", "请添加试卷");
            return;
          }

          if (this.fileInfoList.length + this.fileCoverList.length == 0) {
            this.uploadedSuccessfully();
          } else {
            this.uploadFile();
          }
        }
      } else {
        utils.tips("warning", "请您完善信息");
      }
    },

    //编辑时检验表单是否更改--------------------------------------------
    checkFormChanges() {
      let flag = true;
      for (const key in this.form) {
        if (
          this.form.hasOwnProperty(key) &&
          key != "fileId" &&
          key != "fileIdList" &&
          key != "coverId"
        ) {
          if (this.form[key] != this.oldForm[key]) {
            flag = false;
          }
        }
      }
      return flag;
    },

    //3.上传文件--------------------------------------------
    uploadFile() {
      //展示加载进度
      this.isPercentage = true;
      // 上传文件--------------------------------------------
      this.fileInfoList.forEach((item, index) => {
        this.currentUploadList.push(0);
        this.getPolicie(item, "file", index);
      });

      //上传图片--------------------------------------------
      this.fileCoverList.forEach((item, index) => {
        this.currentUploadList.push(0);
        this.getPolicie(item, "picture", index);
      });
    },

    //4.获取上传凭证--------------------------------------------
    async getPolicie(data, type, index) {
      //获取凭证--------------------------------------------
      let policie = await getUploadPolicies(data);
      let result = policie.data.data;
      let fd = new FormData();
      fd.append("key", result.path); //
      fd.append("OSSAccessKeyId", result.accessid); //
      fd.append("policy", result.policy); //
      fd.append("signature", result.signature); //签名
      fd.append("success_action_status", 200); //
      fd.append("file", data.file); //
      // 上传阿里云--------------------------------------------;
      ossUpload(result.host, fd, this.uploadCallback, index).then(res => {
        //上传阿里云成功后--------------------------------------------
        if (res.status == 200) {
          switch (type) {
            //文件--------------------------------------------
            case "file":
              // 文件列表id
              this.fileIdList.push(result.fileId);
              // 文件id
              this.$set(this.form, "fileId", this.fileIdList[0]);
              //上传成功的数组--------------------------------------------
              this.uploadFileNum.push(result.fileId);
              break;

            //封面--------------------------------------------
            case "picture":
              // 文件封面列表id
              this.fileCoverIdList.push(result.fileId);
              // 文件封面id
              this.$set(this.form, "coverId", this.fileCoverIdList[0]);
              //上传成功的数组--------------------------------------------
              this.uploadFileNum.push(result.fileId);
              break;
          }
        } else {
          console.log("AddETextBook=>上传阿里云失败");
        }
      });
    },

    //上传回调--------------------------------------------
    uploadCallback(progressEvent, index) {
      let uploadData = {
        total: progressEvent.total,
        loaded: progressEvent.loaded
      };
      this.currentUploadList.splice(index, 1, uploadData);
    },

    //删除文件--------------------------------------------
    handleRemove(file) {
      this.fileInfoList.forEach((item, index) => {
        if (item.file.uid == file.uid) {
          //删除对应的文件大小
          this.totalUpload -= item.file.size;
          this.fileInfoList.splice(index, 1);
          this.fileUrlList.splice(index, 1);
          this.$set(this.form, "fileId", this.fileInfoList[0]);
        }
      });
      this.fileList = [];
    },

    //限制上传的文件数量(不限制)--------------------------------------------
    handleExceed(files, fileList) {
      utils.tips("warning", `只能上传一个文件`);
    },

    //跟后台确定上传或修改成功
    uploadedSuccessfully(newVal) {
      //当没上传文件时进来
      if (this.fileInfoList.length + this.fileCoverList.length == 0) {
        if (this.type == "set") {
          setResource("paper", this.form).then(res => {
            if (res.data.success) {
              //关闭加载进度
              this.isPercentage = false;
              utils.tips("success", "修改成功");
              //关闭窗口
              this.closeBtn();
              this.$emit("addSuccess");
            }
          });
        }
        return;
      }

      //当上传成功的数量等于文件和封面的数量时  提交给后台说明图书添加成功
      if (
        newVal.length ==
        this.fileInfoList.length + this.fileCoverList.length
      ) {
        this.$set(this.form, "fileIdList", this.fileIdList);
        if (this.type == "add") {
          addPaper(this.form).then(res => {
            if (res.data.success) {
              //关闭加载进度
              this.isPercentage = false;
              utils.tips("success", "上传成功");
              //关闭窗口
              this.closeBtn();
              this.$emit("addSuccess");
            }
          });
        }

        if (this.type == "set") {
          setResource("paper", this.form).then(res => {
            if (res.data.success) {
              //关闭加载进度
              this.isPercentage = false;
              utils.tips("success", "修改成功");
              //关闭窗口
              this.closeBtn();
              this.$emit("addSuccess");
            }
          });
        }
      }
    },

    //更新dict
    updataDict() {
      for (const key in this.selectDict) {
        if (this.selectDict.hasOwnProperty(key)) {
          this.formList.forEach((item, index) => {
            if (key == "phase" && item.field == "phase") {
              this.$set(
                this.formList[index],
                "optionList",
                this.selectDict[key]
              );
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.add-data {
  user-select: none;
  position: relative;

  width: 100%;
  .percentage-box {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.2);

    /deep/ .el-progress__text {
      color: #24ba58 !important;
    }
  }

  /deep/ .el-dialog {
    overflow: hidden;

    border-radius: 5px;

    // 头部
    .el-dialog__header {
      padding: 20px;

      background-color: #24ba58;

      .el-dialog__title {
        color: #fff;

        user-select: none;
      }

      .el-dialog__close {
        font-size: 20px;

        color: #fff;
      }
    }

    //内容
    .el-dialog__body {
      .item-box {
        display: flex;
        flex-wrap: wrap;

        .el-form-item {
          width: 50%;
        }
      }

      .upload-box {
        .videoList {
          video {
            margin: 20px;
            border: 1px dotted #ccc;
            width: 160px;
            height: 90px;
          }
        }

        .avatar-uploader .el-upload {
          overflow: hidden;

          position: relative;

          border: 1px dashed #d9d9d9;
          border-radius: 6px;

          cursor: pointer;
        }

        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }
        .avatar-uploader-icon {
          position: relative;

          width: 100px;
          height: 100px;

          font-size: 28px;
          line-height: 100px;
          text-align: center;

          color: #8c939d;

          div {
            display: flex;

            position: absolute;
            top: 0;
            left: 0;

            padding-left: 4px;
            width: 100%;

            letter-spacing: 5px;

            justify-content: space-between;
          }
        }
        .avatar {
          display: block;

          width: 100px;
          height: 100px;
        }
      }
    }

    .handleBtn {
      display: flex;

      align-items: center;
      justify-content: center;

      button {
        margin: 0 100px;
        border: 1px solid #24ba58;
        border-radius: 5px;
        width: 80px;
        height: 40px;

        font-size: 14px;
        line-height: 40px;
        text-align: center;
        letter-spacing: 5px;

        color: #fff;
        background-color: #24ba58;

        outline: none;

        transition: all 0.3s;

        cursor: pointer;

        &:hover {
          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);

          transform: translateY(-1px);
        }
      }
    }
  }
}
</style>